<template>
  <div v-if="!isMenuOpen" class="user-profile-container">
    <mc-avatar class="profile" :info="userName" :initials="userAPMId" fit="small"> </mc-avatar>
    <div class="user-name-role">
      <span class="name">{{ userName }}</span>
      <span class="role">{{ userRole }}</span>
    </div>
    <div class="user-profile-menu" @click="toggleProfileMenu">
      <mc-icon size="20" icon="chevron-down" />
    </div>
  </div>
  <ul v-if="showProfileMenu && !isMenuOpen">
    <li class="logout-menu" @click="executeLogout">
      <mc-icon size="20" icon="tray-arrow-up" style="transform: rotate(90deg)"></mc-icon>
      {{ $t("header.userProfileMenu.logout") }}
    </li>
  </ul>
  <ul v-if="isMenuOpen">
    <li>
      {{ $t("header.userProfileMenu.hi") }}<b class="user-name">{{ userName }}</b>
    </li>
    <li>
      <mc-icon size="24" icon="person"></mc-icon>
      {{ $t("header.userProfileMenu.role") }}
      <mc-tag fit="small" appearance="info">{{ userRole }}</mc-tag>
    </li>
    <li class="logout-menu" @click="executeLogout">
      <mc-icon size="20" icon="tray-arrow-up" style="transform: rotate(90deg)"></mc-icon>
      {{ $t("header.userProfileMenu.logout") }}
    </li>
  </ul>
  <div v-if="isMenuOpen" class="dropdown-menu__mask" @click="emits('close')"></div>
  <div v-if="showProfileMenu" class="dropdown-menu__mask" @click="toggleProfileMenu"></div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from "vue";
import "@maersk-global/mds-components-core/mc-icon";
import "@maersk-global/mds-components-core/mc-tag";
import { logout } from "@/authentication/authentication";
import { useGlobals } from "@/utils/globals";

interface Props {
  isMenuOpen: boolean;
  userAPMId: string;
  userName: string;
  userRole: string;
}

const props = withDefaults(defineProps<Props>(), {
  isMenuOpen: false
});
const { $t } = useGlobals();
const showProfileMenu = ref(false);
const emits = defineEmits<{
  (e: "close"): void;
}>();

function toggleProfileMenu() {
  showProfileMenu.value = !showProfileMenu.value;
}

function onKeyDown(event: KeyboardEvent) {
  if (event.key === "Escape" && (showProfileMenu.value || props.isMenuOpen)) {
    showProfileMenu.value = false;
    emits("close");
  }
}

async function executeLogout() {
  emits("close");
  await logout();
}

onMounted(() => {
  document.addEventListener("keydown", onKeyDown);
});

onUnmounted(() => {
  document.removeEventListener("keydown", onKeyDown);
});
</script>

<style scoped>
@import "@/scss/layout/_profileMenu.scss";
</style>
